import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

export function requestBankApproveList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/bank-master`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/bank-master?${params}`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}

export function requestUpdateBankApprove(data) {
  const body = { ...data };
  delete body["_id"];
  return fetch.patch(`${BASE_URL}/api/app/bank-master/togglestatus`, body);
}
